import script from "./StepDurationInline.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepDurationInline.vue?vue&type=script&setup=true&lang=ts"

import "./StepDurationInline.vue?vue&type=style&index=0&id=5955e4b5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5955e4b5"]])

export default __exports__